import { render } from "./travellerDetails.vue?vue&type=template&id=292dca8e&scoped=true"
import script from "./travellerDetails.vue?vue&type=script&lang=js"
export * from "./travellerDetails.vue?vue&type=script&lang=js"

import "./travellerDetails.vue?vue&type=style&index=0&id=292dca8e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-292dca8e"]])

export default __exports__